import { INDUSTRIES } from "@/lib/site-data";
import { ArrowUpRight } from "lucide-react";

export const Industries = () => {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="bg-stone-50 py-24 md:py-32"
    >
      <div className="container-narrow">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-5">
            <div className="overline text-emerald-800 mb-5">— Industries</div>
            <h2 className="font-serif text-3xl md:text-5xl tracking-tight leading-tight text-slate-950">
              Three pillars.<br />
              One operating discipline.
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-slate-600 text-base md:text-lg leading-relaxed">
              Our partners come for sector expertise and stay for our delivery
              discipline. Whether you operate a regulated bank, a water utility
              or a high-growth software company, we bring the same boardroom
              rigor and engineering literacy.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
          {INDUSTRIES.map((ind) => (
            <article
              key={ind.key}
              data-testid={`industry-card-${ind.key}`}
              className="group bg-white p-8 md:p-10 flex flex-col"
            >
              <div className="overflow-hidden mb-8">
                <img
                  src={ind.image}
                  alt={ind.title}
                  className="w-full h-56 object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="overline text-emerald-800 mb-3">{ind.overline}</div>
              <h3 className="font-serif text-2xl md:text-3xl tracking-tight text-slate-950 mb-4">
                {ind.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed mb-6">
                {ind.description}
              </p>
              <ul className="space-y-2 mb-8">
                {ind.bullets.map((b) => (
                  <li
                    key={b}
                    className="text-sm text-slate-700 flex gap-3 items-start"
                  >
                    <span className="mt-2 inline-block w-2 h-px bg-emerald-800 flex-shrink-0" />
                    {b}
                  </li>
                ))}
              </ul>
              <div className="mt-auto pt-6 border-t border-slate-200 flex items-center justify-between">
                <span className="overline text-slate-500">
                  Capability deck on request
                </span>
                <ArrowUpRight
                  size={18}
                  strokeWidth={1.5}
                  className="text-slate-950 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
